var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.message)?_c('div',[_c('div',{staticClass:"msg-item"},[_c('span',{staticClass:"name notice"},[_vm._v(_vm._s(_vm.item.name)+"：")]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.message))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }